import { render, staticRenderFns } from "./DailyStatisticByInstructor.vue?vue&type=template&id=60bdc559&scoped=true"
import script from "./DailyStatisticByInstructor.vue?vue&type=script&lang=ts"
export * from "./DailyStatisticByInstructor.vue?vue&type=script&lang=ts"
import style0 from "./DailyStatisticByInstructor.vue?vue&type=style&index=0&id=60bdc559&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bdc559",
  null
  
)

export default component.exports